<template>
    <create-dialog :event="save" @close="close" title="Changelog aanmaken" :loading="loading">
        <Fields v-model="newChangelog" :validations="$v.newChangelog"/>
        <template v-slot:button="{ on, attrs }">
            <v-btn class="mb-2" v-on="on" v-bind="attrs" color="success">
                <v-icon class="mr-2">mdi-plus</v-icon>
                <p class="mt-4">Nieuwe changelog</p>
            </v-btn>
        </template>
    </create-dialog>
</template>

<script>
import Fields from "@/components/Changelog/Fields.vue";
import {required} from "vuelidate/lib/validators";
import Changelog from "@/models/Changelog/Changelog";
import CreateDialog from "@/components/General/Dialog/CreateDialog.vue";

export default {
    components: {
        CreateDialog,
        Fields,
    },
    data() {
        return {
            newChangelog: {},
            dialog: false,
            loading: false,
        }
    },
    validations: {
        newChangelog: {
            version: {
                required,
            },
            content: {
                required,
            }
        }
    },
    methods: {
        save() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                return Changelog.api().create(this.newChangelog).then(() => {
                    this.dialog = false;
                });
            }
        },
        close() {
            this.newChangelog = {};
        }
    },

}
</script>
